import Styles from "./styles";
import { useState, useEffect } from "react";

function Popup({ data, index, onClose }) {
  const [isVisible, setIsVisible] = useState(true);

  // 오늘 하루 보지않기 체크
  useEffect(() => {
    const hiddenPopups = JSON.parse(
      localStorage.getItem("hiddenPopups") || "{}"
    );
    const today = new Date().toDateString();

    if (hiddenPopups[data.id] === today) {
      setIsVisible(false);
    }
  }, [data.id]);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose(data.id);
  };

  const handleHideToday = () => {
    const hiddenPopups = JSON.parse(
      localStorage.getItem("hiddenPopups") || "{}"
    );
    const today = new Date().toDateString();
    hiddenPopups[data.id] = today;
    localStorage.setItem("hiddenPopups", JSON.stringify(hiddenPopups));
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <Styles.Container index={index}>
      <Styles.CloseButton onClick={handleClose}>&times;</Styles.CloseButton>

      <Styles.Content>
        {data.image && (
          <Styles.Image>
            <img src={data.image} alt="popup" />
          </Styles.Image>
        )}
        <Styles.Description
          dangerouslySetInnerHTML={{ __html: data.description }}
        />
      </Styles.Content>

      <Styles.ButtonGroup>
        <Styles.HideTodayButton onClick={handleHideToday}>
          오늘 하루 보지않기
        </Styles.HideTodayButton>
        <Styles.CloseTextButton onClick={handleClose}>
          닫기
        </Styles.CloseTextButton>
      </Styles.ButtonGroup>
    </Styles.Container>
  );
}

export default Popup;
